import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { DatePipe, CommonModule } from '@angular/common';
import { EIPToastAlertComponent, EIPToastAlertModule } from 'eiptoast-alert';
import * as i2 from '@progress/kendo-angular-intl';
import { IntlModule } from '@progress/kendo-angular-intl';
import * as i3 from '@angular/material/snack-bar';
import * as i4 from '@progress/kendo-angular-dateinputs';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import * as i5 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { LabelModule } from '@progress/kendo-angular-label';
import { PopupModule } from '@progress/kendo-angular-popup';
import { InputsModule } from '@progress/kendo-angular-inputs';

class EIPDatePickerService {
    constructor() { }
}
EIPDatePickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EIPDatePickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class EIPDatePickerComponent {
    constructor(datePipe, intl, _snackBar) {
        this.datePipe = datePipe;
        this.intl = intl;
        this._snackBar = _snackBar;
        this.IsDateTimeRequired = false;
        this.IsDateDisabled = false;
        this.timeFormate = 'hh:mm a';
        this.IsTimeDisabled = false;
        this.selectedDate = new EventEmitter();
        this.selectedTime = new EventEmitter();
        this.IsDateReadonly = false;
        this.clearValue = 'N';
        this.EnableEmittingOnblur = false;
        this.value = new Date(2000, 2, 10, 10, 30, 0);
        this.events = [];
        // Set time to NOW
        this.value1 = new Date();
    }
    // constructor() { }
    onBlur() {
        this.log('blur');
    }
    onFocus() {
        this.log('focus');
    }
    onOpen() {
        this.log('open');
    }
    onClose() {
        this.log('close');
    }
    onChange(value) {
        this.log('change', this.value1);
    }
    log(event, value) {
        this.events = [`${event}${this.formatValue(this.value1)}`].concat(this.events);
    }
    formatValue(value) {
        return value ? ` - ${this.intl.formatDate(this.value1, 'd')}` : '';
    }
    ngOnInit() {
        // this.maxMinValidation()
        // this.currentdate = new Date().toLocaleString().split(',')[1].trim
        // this.today  = this.datePipe.transform(this.today , "h:mm a")
        // this.today  = this.datePipe.transform(this.currentdate , "h:mm a")
        // console.log(this.currentdate);
    }
    maxMinValidation() {
        let minValValue;
        let min_Original_Value;
        min_Original_Value = this.Min;
        min_Original_Value = this.datePipe.transform(min_Original_Value, 'dd-MMM-yyyy');
        minValValue = new Date();
        minValValue = this.datePipe.transform(minValValue, 'dd-MMM-yyyy');
        if (this.Max) {
            this.Max = new Date(this.Max.getFullYear(), this.Max.getMonth() - 1, this.Max.getDate(), 10, 31);
        }
        if (this.Min) {
            if (min_Original_Value >= minValValue) {
                this.Min = new Date(this.Min.getFullYear(), this.Min.getMonth(), this.Min.getDate(), 10, 31);
            }
            else {
                this.Min = new Date(this.Min.getFullYear(), this.Min.getMonth() - 1, this.Min.getDate(), 10, 31);
            }
        }
        if (this.Value) {
            this.Value = new Date(this.Value.getFullYear(), this.Value.getMonth() - 1, this.Value.getDate(), 10, 31);
        }
    }
    // emitText() {
    //   let value = this.Value
    //   this.selectedDate.emit({ value })
    // }
    emitText(emitter, event) {
        if (!this.EnableEmittingOnblur) {
            let value;
            let isDateTime;
            if (emitter == 'date') {
                value = this.Value;
                isDateTime = false;
                // value = this.datePipe.transform(value, 'dd-MMM-yyyy');
            }
            else if (emitter == 'time') {
                value = this.value1;
                isDateTime = true;
                // value = this.datePipe.transform(value, 'h:mm a');
            }
            if (value) {
                value = this.datePipe.transform(value, (isDateTime) ? 'h:mm a' : 'dd-MMM-yyyy');
                const yearLength = new Date(value.substr(value.length - 4)).getFullYear().toString().length;
                if (yearLength === 4) {
                    this.checkValidation(event);
                    // this.selectedTime.emit({ value })
                }
            }
        }
    }
    onBlurEmittingDate() {
        if (this.EnableEmittingOnblur) {
            if (this.Value) {
                let value = this.datePipe.transform(this.Value, 'dd-MMM-yyyy');
                const yearLength = new Date(value.substr(value.length - 4)).getFullYear().toString().length;
                if (yearLength === 4) {
                    this.checkValidation(value);
                }
            }
            else {
                this.selectedDate.emit(null);
            }
        }
    }
    showErrorToast(message) {
        const _message = message;
        const _messageType = 'Error';
        this._snackBar.openFromComponent(EIPToastAlertComponent, {
            panelClass: 'eip-toast-message-error',
            duration: 1000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
            data: { _message, _messageType }
        });
    }
    emitTextTime(event) {
        let timeget;
        // timeget = event.value.toLocaleTimeString();'h:mm:ss a'
        timeget = this.datePipe.transform(event.value, this.timeFormate);
        this.selectedTime.emit(timeget);
    }
    // OnKeyPress(value: Date) {
    //   console.log("keypress" + this.value1);
    // }
    ngOnChanges() {
        if (this.clearValue == 'Y') {
            this.Value = null;
        }
        if (this.Value) {
            // console.log(this.Value, "Date selected")
        }
    }
    handleValidation(selectedDate) {
        // let _dateArray: string[] = [] // selectedDate.toLocaleString()
        // _dateArray = selectedDate.split("-")
        if (selectedDate) {
            let _year = selectedDate.getFullYear(); // Number(_dateArray[_dateArray.length - 1])
            if (_year > 2099) {
                this.Value.setFullYear(2099);
                // console.log(this.Value)
            }
        }
    }
    checkValidation(selectedDate) {
        if (!selectedDate) {
            selectedDate = this.Value;
        }
        const value = this.datePipe.transform(this.Value, 'dd-MMM-yyyy');
        if (value) {
            const yearLength = new Date(value.substr(value.length - 4)).getFullYear().toString().length;
            if (yearLength === 4) {
                if (this.Min && this.Max && (selectedDate < this.Min || selectedDate > this.Max)) {
                    this.showErrorToast('Selected date should be between min and max dates!');
                    this.Value = this.Min ? this.Min : (this.Max ? this.Max : new Date());
                    selectedDate = this.Value;
                }
                this.selectedDate.emit({ value });
            }
        }
    }
}
EIPDatePickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerComponent, deps: [{ token: i1.DatePipe }, { token: i2.IntlService }, { token: i3.MatSnackBar }], target: i0.ɵɵFactoryTarget.Component });
EIPDatePickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: EIPDatePickerComponent, selector: "EIPDatePicker", inputs: { Value: "Value", timeValue: "timeValue", Time: "Time", Min: "Min", Max: "Max", setId: "setId", textss: "textss", WaterMark: "WaterMark", setMinTime: "setMinTime", IsDateTimeRequired: "IsDateTimeRequired", IsDateDisabled: "IsDateDisabled", timeFormate: "timeFormate", IsTimeDisabled: "IsTimeDisabled", IsDateReadonly: "IsDateReadonly", clearValue: "clearValue", EnableEmittingOnblur: "EnableEmittingOnblur" }, outputs: { selectedDate: "selectedDate", selectedTime: "selectedTime" }, providers: [DatePipe], usesOnChanges: true, ngImport: i0, template: "<table class=\"eipdate-picker-table\" style=\"width: 100%\">\r\n  <tr>\r\n    <td [ngStyle]=\"{'width': (IsDateTimeRequired == true)? '50%': '0.5%'}\">\r\n\r\n      <!-- (keypress)=\"OnKeyPress()\" -->\r\n      <!-- <kendo-textbox-container [ngClass] = \"IsDateDisabled ? 'datepickerdisable' : ''\"  [floatingLabel]=\"WaterMark\"> -->\r\n      <kendo-datepicker class=\"eip-date-picker\" [readOnlyInput]=\"IsDateReadonly\" (blur)=\"onBlurEmittingDate()\"\r\n        [min]=\"Min\" [max]=\"Max\" [format]=\"'dd-MMM-yyyy'\" [disabled]=\"IsDateDisabled\" [placeholder]=\"WaterMark\"\r\n        [popupSettings]=\"{popupClass: textss}\" [id]=\"setId\" [(ngModel)]=\"Value\" (valueChange)=\"emitText('date', $event)\"\r\n        (ngModelChange)='handleValidation($event)'>\r\n      </kendo-datepicker>\r\n      <!-- </kendo-textbox-container> -->\r\n    </td>\r\n\r\n\r\n    <td *ngIf=\"IsDateTimeRequired==true\" style=\"width: 50%\">\r\n      <!-- <kendo-timepicker [value]=\"value\"   [(ngModel)]=\"value\" (valueChange)=\"emitText('time')\"></kendo-timepicker> -->\r\n      <kendo-timepicker #timeval class=\"eip-time-picker\" [min]=\"setMinTime\" (blur)=\"onBlur()\" (focus)=\"onFocus()\"\r\n        (open)=\"onOpen()\" [format]=\"timeFormate\" [disabled]=\"IsTimeDisabled\" (close)=\"onClose()\"\r\n        (valueChange)=\"emitTextTime(timeval)\" [value]=\"Value\">\r\n      </kendo-timepicker>\r\n    </td>\r\n  </tr>\r\n</table>", styles: [".k-calendar .k-state-selected .k-link{border-color:#258cb7!important;color:#fff;background-color:#1d75ae!important}.k-calendar .k-calendar-header{background:#1d75ae;color:#fff}.k-calendar .k-calendar-header .k-today{color:#fff}.k-time-header .k-time-now,.k-time-list .k-item:hover{color:#1d75ae}.k-calendar .k-calendar-header{height:32px!important}.k-calendar .k-month .k-link,.k-calendar .k-calendar-monthview .k-link{width:30px!important;height:30px!important}.k-calendar .k-content .k-today{color:#1d75ae}.datepickerdisable{opacity:.2}::ng-deep .k-datepicker .k-picker-wrap.k-state-focused,.k-picker-wrap.k-state-focused{box-shadow:none!important}::ng-deep .k-datepicker .k-picker-wrap.k-state-focused,.k-picker-wrap.k-state-focused{border:0px!important}::ng-deep\\a0  .k-timepicker\\a0.k-picker-wrap.k-state-focused,::ng-deep\\a0  .k-timepicker\\a0.k-picker-wrap:hover{border-color:#333!important}::ng-deep\\a0 eipdatepicker\\a0  .k-textbox-container\\a0.k-dateinput\\a0.k-dateinput-wrap\\a0.k-input{padding:\\a0 5px\\a0 0\\a0 0\\a0 0\\a0!important}::ng-deep\\a0 eipdatepicker\\a0td{border-color:#fff!important;padding:\\a0 0px\\a0!important}.k-dateinput .k-dateinput-wrap .k-input,.k-datepicker .k-dateinput-wrap .k-input,.k-datepicker .k-picker-wrap .k-input{padding-left:0}::ng-deep .k-popup .k-calendar .k-calendar-monthview td{width:35px!important;height:30px!important;padding-right:6px}::ng-deep .k-datepicker.ng-invalid.ng-touched .k-picker-wrap,.k-datepicker.ng-invalid.ng-touched .k-picker-wrap.k-state-focused,.k-datepicker.ng-invalid.ng-touched .k-picker-wrap:focus,.k-datepicker.ng-invalid.ng-touched .k-picker-wrap:active{border-color:#333}@media (max-width: 575px){::ng-deep .k-popup .k-calendar-navigation{width:4em;font-size:14px}::ng-deep .k-popup .k-calendar-infinite .k-calendar-view,::ng-deep .k-popup .k-calendar-infinite .k-calendar-monthview{padding:0 5px}::ng-deep .k-popup .k-calendar .k-calendar-header{padding:0 10px}::ng-deep .k-popup .k-calendar .k-calendar-header span:last-child{padding-right:10px}::ng-deep .k-popup .k-calendar-infinite .k-calendar-view{width:250px}::ng-deep .k-popup .k-popup .k-calendar .k-calendar-monthview td{padding-right:6px}}.k-input{height:calc(1.4285714286em)}\n"], components: [{ type: i4.DatePickerComponent, selector: "kendo-datepicker", inputs: ["focusableId", "activeView", "bottomView", "topView", "disabled", "readonly", "readOnlyInput", "navigation", "min", "max", "incompleteDateValidation", "focusedDate", "format", "placeholder", "tabindex", "title", "rangeValidation", "disabledDatesValidation", "weekNumber", "cellTemplate", "monthCellTemplate", "yearCellTemplate", "decadeCellTemplate", "centuryCellTemplate", "weekNumberTemplate", "headerTitleTemplate", "navigationItemTemplate", "popupSettings", "value", "tabIndex", "disabledDates", "formatPlaceholder"], outputs: ["valueChange", "focus", "blur", "open", "close"], exportAs: ["kendo-datepicker"] }, { type: i4.TimePickerComponent, selector: "kendo-timepicker", inputs: ["focusableId", "disabled", "readonly", "readOnlyInput", "format", "placeholder", "incompleteDateValidation", "cancelButton", "nowButton", "tabindex", "title", "rangeValidation", "min", "max", "steps", "popupSettings", "tabIndex", "value", "formatPlaceholder"], outputs: ["valueChange", "focus", "blur", "open", "close"], exportAs: ["kendo-timepicker"] }], directives: [{ type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'EIPDatePicker', providers: [DatePipe], template: "<table class=\"eipdate-picker-table\" style=\"width: 100%\">\r\n  <tr>\r\n    <td [ngStyle]=\"{'width': (IsDateTimeRequired == true)? '50%': '0.5%'}\">\r\n\r\n      <!-- (keypress)=\"OnKeyPress()\" -->\r\n      <!-- <kendo-textbox-container [ngClass] = \"IsDateDisabled ? 'datepickerdisable' : ''\"  [floatingLabel]=\"WaterMark\"> -->\r\n      <kendo-datepicker class=\"eip-date-picker\" [readOnlyInput]=\"IsDateReadonly\" (blur)=\"onBlurEmittingDate()\"\r\n        [min]=\"Min\" [max]=\"Max\" [format]=\"'dd-MMM-yyyy'\" [disabled]=\"IsDateDisabled\" [placeholder]=\"WaterMark\"\r\n        [popupSettings]=\"{popupClass: textss}\" [id]=\"setId\" [(ngModel)]=\"Value\" (valueChange)=\"emitText('date', $event)\"\r\n        (ngModelChange)='handleValidation($event)'>\r\n      </kendo-datepicker>\r\n      <!-- </kendo-textbox-container> -->\r\n    </td>\r\n\r\n\r\n    <td *ngIf=\"IsDateTimeRequired==true\" style=\"width: 50%\">\r\n      <!-- <kendo-timepicker [value]=\"value\"   [(ngModel)]=\"value\" (valueChange)=\"emitText('time')\"></kendo-timepicker> -->\r\n      <kendo-timepicker #timeval class=\"eip-time-picker\" [min]=\"setMinTime\" (blur)=\"onBlur()\" (focus)=\"onFocus()\"\r\n        (open)=\"onOpen()\" [format]=\"timeFormate\" [disabled]=\"IsTimeDisabled\" (close)=\"onClose()\"\r\n        (valueChange)=\"emitTextTime(timeval)\" [value]=\"Value\">\r\n      </kendo-timepicker>\r\n    </td>\r\n  </tr>\r\n</table>", styles: [".k-calendar .k-state-selected .k-link{border-color:#258cb7!important;color:#fff;background-color:#1d75ae!important}.k-calendar .k-calendar-header{background:#1d75ae;color:#fff}.k-calendar .k-calendar-header .k-today{color:#fff}.k-time-header .k-time-now,.k-time-list .k-item:hover{color:#1d75ae}.k-calendar .k-calendar-header{height:32px!important}.k-calendar .k-month .k-link,.k-calendar .k-calendar-monthview .k-link{width:30px!important;height:30px!important}.k-calendar .k-content .k-today{color:#1d75ae}.datepickerdisable{opacity:.2}::ng-deep .k-datepicker .k-picker-wrap.k-state-focused,.k-picker-wrap.k-state-focused{box-shadow:none!important}::ng-deep .k-datepicker .k-picker-wrap.k-state-focused,.k-picker-wrap.k-state-focused{border:0px!important}::ng-deep\\a0  .k-timepicker\\a0.k-picker-wrap.k-state-focused,::ng-deep\\a0  .k-timepicker\\a0.k-picker-wrap:hover{border-color:#333!important}::ng-deep\\a0 eipdatepicker\\a0  .k-textbox-container\\a0.k-dateinput\\a0.k-dateinput-wrap\\a0.k-input{padding:\\a0 5px\\a0 0\\a0 0\\a0 0\\a0!important}::ng-deep\\a0 eipdatepicker\\a0td{border-color:#fff!important;padding:\\a0 0px\\a0!important}.k-dateinput .k-dateinput-wrap .k-input,.k-datepicker .k-dateinput-wrap .k-input,.k-datepicker .k-picker-wrap .k-input{padding-left:0}::ng-deep .k-popup .k-calendar .k-calendar-monthview td{width:35px!important;height:30px!important;padding-right:6px}::ng-deep .k-datepicker.ng-invalid.ng-touched .k-picker-wrap,.k-datepicker.ng-invalid.ng-touched .k-picker-wrap.k-state-focused,.k-datepicker.ng-invalid.ng-touched .k-picker-wrap:focus,.k-datepicker.ng-invalid.ng-touched .k-picker-wrap:active{border-color:#333}@media (max-width: 575px){::ng-deep .k-popup .k-calendar-navigation{width:4em;font-size:14px}::ng-deep .k-popup .k-calendar-infinite .k-calendar-view,::ng-deep .k-popup .k-calendar-infinite .k-calendar-monthview{padding:0 5px}::ng-deep .k-popup .k-calendar .k-calendar-header{padding:0 10px}::ng-deep .k-popup .k-calendar .k-calendar-header span:last-child{padding-right:10px}::ng-deep .k-popup .k-calendar-infinite .k-calendar-view{width:250px}::ng-deep .k-popup .k-popup .k-calendar .k-calendar-monthview td{padding-right:6px}}.k-input{height:calc(1.4285714286em)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.DatePipe }, { type: i2.IntlService }, { type: i3.MatSnackBar }]; }, propDecorators: { Value: [{
                type: Input
            }], timeValue: [{
                type: Input
            }], Time: [{
                type: Input
            }], Min: [{
                type: Input
            }], Max: [{
                type: Input
            }], setId: [{
                type: Input
            }], textss: [{
                type: Input
            }], WaterMark: [{
                type: Input
            }], setMinTime: [{
                type: Input
            }], IsDateTimeRequired: [{
                type: Input
            }], IsDateDisabled: [{
                type: Input
            }], timeFormate: [{
                type: Input
            }], IsTimeDisabled: [{
                type: Input
            }], selectedDate: [{
                type: Output
            }], selectedTime: [{
                type: Output
            }], IsDateReadonly: [{
                type: Input
            }], clearValue: [{
                type: Input
            }], EnableEmittingOnblur: [{
                type: Input
            }] } });

class EIPDatePickerModule {
}
EIPDatePickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
EIPDatePickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerModule, declarations: [EIPDatePickerComponent], imports: [CommonModule, IntlModule,
        DateInputsModule, LabelModule, FormsModule, PopupModule, InputsModule,
        EIPToastAlertModule], exports: [EIPDatePickerComponent] });
EIPDatePickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerModule, imports: [[CommonModule, IntlModule,
            DateInputsModule, LabelModule, FormsModule, PopupModule, InputsModule,
            EIPToastAlertModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EIPDatePickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EIPDatePickerComponent],
                    imports: [CommonModule, IntlModule,
                        DateInputsModule, LabelModule, FormsModule, PopupModule, InputsModule,
                        EIPToastAlertModule
                    ],
                    exports: [EIPDatePickerComponent]
                }]
        }] });

/*
 * Public API Surface of eipdate-picker
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EIPDatePickerComponent, EIPDatePickerModule, EIPDatePickerService };
